import React, { useState } from "react";
import { useLazyExportProjectQuery } from "../../store/slices/settingsSlice";
import { Form } from "react-bootstrap";
import Input from "../nodes/Logic/Inputs/Input";

export default function ProjectExportModal({
  projectId,
  projectName,
}: {
  projectId: number;
  projectName: string;
}) {
  const [exportProject] = useLazyExportProjectQuery();
  const [fileName, setFileName] = useState(
    projectName + ".json" || "exported_project.json"
  );
  const [p, setp] = useState(projectName || "exported_project");
  const [isSameAccount, setIsSameAccount] = useState(true);

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>File name</Form.Label>
        <Form.Control
          type="text"
          placeholder="File name"
          value={fileName}
          onChange={(e) => setFileName(e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Project label</Form.Label>
        <Form.Control
          type="text"
          placeholder="Project label"
          value={p}
          onChange={(e) => setp(e.target.value)}
        />
      </Form.Group>
      <div className="mb-3">
        <Input
          label="Export component for the same account"
          inputType="checkbox"
          value={[isSameAccount]}
          onChange={([v]: any[]) => setIsSameAccount(v)}
          options={[
            { label: "yes", value: true },
            { label: "no", value: false },
          ]}
        />
      </div>
      <button
        type="button"
        className="btn btn-colored"
        onClick={async () => {
          const result = await exportProject({ projectId, isSameAccount });
          if (result?.data) {
            // Create element with <a> tag
            const link = document.createElement("a");

            // Create a blog object with the file content which you want to add to the file
            const file = new Blob(
              [JSON.stringify({ ...result.data, Label: p }, null, 2)],
              {
                type: "text/plain",
              }
            );

            // Add file content in the object URL
            link.href = URL.createObjectURL(file);

            // Add file name
            link.download = fileName;

            // Add click event to <a> tag to save file.
            link.click();
            URL.revokeObjectURL(link.href);
          }
        }}
      >
        Export component
      </button>
    </>
  );
}
